import { setCookie } from "../../services/service-cookies";
import { getCookie } from "../../services/service-cookies";

export default class GlobalAlert {
  constructor(element) {
    this.el = element
    this.button = this.el.querySelector("[data-alert]");
    this.init()
  }
  
  init() {
    let showAlert = getCookie("showAlert");

    if (!showAlert) {
     setCookie("showAlert", "true", 1)
        this.el.classList.remove("hidden");
    }
    else {
      if (showAlert == "true") { 
        this.el.classList.remove("hidden");
      }
    }  

    this.button.addEventListener('click', e => {
          this.el.classList.add("hidden"); 
          setCookie("showAlert", "false", 1)
        }) 
  }
}
  
     